module.exports = __webpack_public_path__ + "static/media/kinedu-educators-en.f1b9b837.svg";